import { gql } from '@apollo/client';

export const PROPERTY_VIEWINGS_FRAGMENT = gql`
  fragment PropertyViewings on Property {
    viewings {
      list {
        id
        from
        to
      }
    }
  }
`;
